import React from 'react';
import { i18n } from 'utils/i18n';
import utils from '@ehi/global-marketing-interface/lib/utils';
import useActions from 'hooks/useActions';
import { setDiscountCodeExpanded } from 'actions/bookingWidget';
import Button from 'components/Button';
import { RESERVATIONS } from 'constants';

const CouponContract = ({
  handleEdit,
  stepTwo,
  hideEditButtons,
  isTabletOrMobile,
  reservationContractAndCoupons,
  contractName,
  navigate,
  isRental,
}) => {
  const isContractAndCouponsFieldEmpty = !utils.isArrayNotEmpty(reservationContractAndCoupons);
  const dispatchDiscountCodesExpandedTab = useActions(setDiscountCodeExpanded);
  const CouponAndContractAddorEditTextKey = isContractAndCouponsFieldEmpty
    ? i18n('rental_details_add')
    : i18n('rental_details_edit');
  const CouponAndContractTitle = i18n('rental_details_coupon_contract');

  const handleEditClick = (sectionPath) => {
    const path = RESERVATIONS?.RESFLOW_PATHS_CONFIG?.[sectionPath][0];
    if (path) {
      navigate(path);
    }
    dispatchDiscountCodesExpandedTab(true);
  };

  const ariaLabelText = isContractAndCouponsFieldEmpty
    ? i18n('rental_details_add_aria_label')
    : i18n('rental_details_edit_aria_label');

  return (
    <div className='rental-details__section'>
      <p className='rental-details__section-label'>
        <span>{CouponAndContractTitle}</span>
        {handleEdit && !stepTwo && (!hideEditButtons || isTabletOrMobile) && (
          <Button
            link
            onClick={() => handleEditClick('start')}
            data-dtm-track={`rental_details|COUPONS & CONTRACTS|${isContractAndCouponsFieldEmpty ? 'add' : 'edit'}`}
            ariaText={i18n(ariaLabelText, [CouponAndContractTitle])}
          >
            {CouponAndContractAddorEditTextKey}
          </Button>
        )}
      </p>
      {utils.isArrayNotEmpty(reservationContractAndCoupons) &&
        reservationContractAndCoupons.map((coupon, index) => (
          <p key={index} className='rental-details__coupon-contract-label'>
            {coupon.description}
          </p>
        ))}
      {!isRental && !utils.isArrayNotEmpty(reservationContractAndCoupons) && (
        <p className='rental-details__coupon-contract-empty'>
          {i18n('rental_details_coupon_contract_missing_discount')}
        </p>
      )}

      {contractName && <p className='rental-details__coupon-contract-empty'>{contractName}</p>}
    </div>
  );
};

export default CouponContract;
